import { render, staticRenderFns } from "./ChatModalGroupPicture.vue?vue&type=template&id=3c7374da&scoped=true&"
import script from "./ChatModalGroupPicture.vue?vue&type=script&lang=js&"
export * from "./ChatModalGroupPicture.vue?vue&type=script&lang=js&"
import style0 from "./ChatModalGroupPicture.vue?vue&type=style&index=0&id=3c7374da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7374da",
  null
  
)

export default component.exports